import { render, staticRenderFns } from "./gift-with-purchase.vue?vue&type=template&id=195c8f2d&scoped=true&"
import script from "./gift-with-purchase.vue?vue&type=script&lang=js&"
export * from "./gift-with-purchase.vue?vue&type=script&lang=js&"
import style0 from "./gift-with-purchase.vue?vue&type=style&index=0&id=195c8f2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c8f2d",
  null
  
)

export default component.exports